import IconButton from "@material-ui/core/IconButton";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useAppContext } from "../../../context/AuthContext";
import MessageType from "../../../utils/MessageType";

interface CopyTextType {
  text: string;
}

export default function CopyText({ text }: CopyTextType) {
  const { showMessage } = useAppContext();

  return (
    <CopyToClipboard text={text} onCopy={() => showMessage("Copied", MessageType.SUCCESS)}>
      <IconButton color="primary" aria-label="upload picture" title="Copy title" component="span">
        <FileCopyIcon />
      </IconButton>
    </CopyToClipboard>
  );
}
